<template>
  <div class="producttype _contract">
    <form v-on:submit.prevent="ButtonNext()"> 
      <div class="row m-0 navigation">
        <b-button-group class="row mx-0 px-4 navigation">
          <b-button @click="ButtonPrev">
            <img  src = "@/assets/image/icon/icon-rectangle.svg">
            Back
          </b-button>
          <b-button type="submit">
            Next
            <img  src = "@/assets/image/icon/icon-rectangle.svg">
          </b-button>
        </b-button-group>
      </div>
      <div class="row m-0 product_type __centerblock">
        <div class="col text-center">
            <h3 class="text-center __titleGlobal">Choose Your Product Type</h3>
            <div class="row m-0 justify-content-center">
              <div
                class="__block"
                @click="chooseProductType('General Cargo')"
                v-bind:class="{ active: isGeneral }"
              >
                <div class="row m-0 justify-content-center">
                  <img class="__img" src = "@/assets/image/instantprice/shirt.png">
                  <p class="__title">General Cargo</p>
                </div>
              </div>
              <div
                class="__block"
                @click="chooseProductType('Special Cargo')"
                v-bind:class="{ active: isSpecial }"
              >
                <div class="row m-0 justify-content-center">
                  <img class="__img" src = "@/assets/image/instantprice/diet.png">
                  <p class="__title">Special Cargo</p>
                </div>
              </div>
              <div
                class="__block"
                type="button"
                name="button"
                @click="chooseProductType('Dangerous Goods')"
                v-bind:class="{ active: isDangerous }"
              >
                <div class="row m-0 justify-content-center">
                  <img class="__img" src = "@/assets/image/instantprice/caution.png">
                  <p class="__title">Dangerous Goods</p>
                </div>
              </div>
            </div>
            
            <div class="__inputfield4">
              <div class="row m-0 justify-content-between">
                <div class="col-md-6 pl-0">
                  <div class="__customdropdown4">
                    <p>What kind of goods you shipped?</p>
                    <b-input-group>
                      <b-dropdown no-flip>
                        <template slot="button-content">
                          <p class="m-0" :class="data.product_type ? 'item__selected' : ''"> {{ kindOfGoods }} </p>
                        </template>
                        <div v-if="isGoods === 'General Cargo'">
                          <b-dropdown-item @click="selectedOption(goodsType.text)" v-for="(goodsType,i) in goodsGeneral" :key="i" >
                            <span>{{ goodsType.text }}</span>
                          </b-dropdown-item>
                        </div>
                        <div v-if="isGoods === 'Special Cargo'">
                          <b-dropdown-item @click="selectedOption(goodsType.text)" v-for="(goodsType,i) in goodsSpecial" :key="i">
                            <span>{{ goodsType.text }}</span>
                          </b-dropdown-item>
                        </div>
                        <div v-if="isGoods === 'Dangerous Goods'">
                          <b-dropdown-item @click="selectedOption(goodsType.text)" v-for="(goodsType,i) in goodsDangerous" :key="i">
                            <span>{{ goodsType.text }}</span>
                          </b-dropdown-item>
                        </div>
                        <div class="global__bform--default">
                          <b-dropdown-form @click="selectedOption('Others')">
                            <b-form-group label="Others" label-for="dropdown-other-selected" @submit.stop.prevent>
                              <div v-if="othersGoods.show" class="input__line row m-0">
                                <b-form-input
                                  style="width: 80%;"
                                  id="dropdown-other-selected"
                                  v-model="othersGoods.value"
                                  placeholder="Please Specify (e.g Chemicals .etc)"
                                  required
                                ></b-form-input>
                                <div class="styleenter pl-2" style="width: 20%;"
                                    @click="selectedOption('Others')">Enter</div>
                              </div>
                            </b-form-group>
                          </b-dropdown-form>
                        </div>
                      </b-dropdown>
                    </b-input-group>
                    <p v-if="error.goods" class="fontstyle__errormsg">
                      {{error.goods}}
                    </p>
                  </div>
                  <div class=" __code">
                    <p>HS Code</p>
                    <b-input-group class="__input">
                      <b-form-input
                        type="text"
                        v-validate="'required'"
                        name="HS Code" :state="errors.first('HS Code') && false"
                        placeholder="0"
                        v-model="data.hs_code"
                      />
                    </b-input-group>
                    <p v-if="errors.has('HS Code')" class="fontstyle__errormsg">
                      {{ errors.first('HS Code') }}
                    </p>
                  </div>
                  <div class="__description">
                    <p>Product Description</p>
                    <b-form-textarea
                      id="textarea"
                      name="Description"
                      placeholder="Type Your Product Description"
                      rows="3"
                      max-rows="5"
                      v-validate="'required'"
                      :state="errors.first('Description') && false"
                      class="__textarea"
                      v-model="data.description"
                    />
                    <p v-if="errors.has('Description')" class="fontstyle__errormsg">
                        {{ errors.first('Description') }}
                    </p>
                  </div>
                </div>
                <div class="col-md-4 pr-0">
                  <div class="__goods m-0">
                    <p>Value of goods (IDR)</p>
                    <b-input-group class="__input">
                      <money class="__money" :class="data.total_price === 0 ? 'init_value' : ''" v-model="data.total_price" :value="data.total_price" ></money>
                    </b-input-group>
                    <p v-if="data.total_price < 1" class="fontstyle__errormsg">
                      {{error.valueGoods}}
                    </p>
                  </div>
                  <div class="__goods" v-if="data.commoditiesClass === 'DG'">
                    <p>UN Number</p>
                    <b-input-group class="__input">
                      <b-form-input type="text"
                                    v-model="data.un_number"
                                    placeholder="0"
                                    name="UN Number"
                                    v-validate="'required'"
                                    :state="errors.first('UN Number') && false"/>
                    </b-input-group>
                    <p v-if="errors.has('UN Number')" class="fontstyle__errormsg">
                        {{ errors.first('UN Number') }}
                    </p>
                  </div>
                  <div class="input__attachblue mb-2">
                    <p class="textdefault">Attach MSDS
                      <span v-if="data.commoditiesClass !== 'DG'">(Optional)</span>
                    </p>
                    <b-form-file
                            :required="data.commoditiesClass === 'DG'"
                            v-model="data.fileDocument"
                            name="Attach MSDS"
                            accept=".pdf, .xls, .doc, .docx, .xlsx"
                            id="fileDocument"
                            ref="fileDocument" />
                    <p class="textdefault mt-1" style="font-size:10px">*Maximum file size 5MB</p>
                    <p v-if="errors.has('Attach MSDS')" class="fontstyle__errormsg mt-1">
                          {{ errors.first('Attach MSDS') }}
                    </p>
                    <p v-if="error.fileDocument" class="fontstyle__errormsg mt-1">
                      {{error.fileDocument}}
                    </p>
                  </div>
                </div>
              </div>
            </div>  <!-- end __inputfield -->
        </div>
      </div>
    </form>
    
  </div>
</template>

<script>
export default {
  name: 'product_type',
  data () {
    return {
      fileNameMSDS: 'Attach File',
      isGeneral: true,
      isSpecial: false,
      isDangerous: false,
      isGoods: 'General Cargo',
      kindOfGoods: 'What kind of goods you shipped ?',
      data: {
        total_price: 0,
        hs_code: '',
        product_type: '',
        commoditiesClass: 'GENCO',
        description: '',
        productDescription: '',
        fileDocument: null,
        fileDocumentStat: true,
        fileTypeStat: true,
        un_number: ''
      },
      goodsGeneral: [
        { text: 'Food and Beverages' },
        { text: 'Machinery and Spareparts' },
        { text: 'Paper and Plastics' },
        { text: 'Textile and Garment' },
        { text: 'Perishable' }
      ],
      goodsSpecial: [
        { text: 'Live Animal (AVI)' },
        { text: 'Human Remain (HUM)' },
        { text: 'Perishable Goods (PER)' },
        { text: 'Valuable Goods (VAL)' },
        { text: 'Smelling Goods' },
        { text: 'Live Human Organ (LHO)' }
      ],
      goodsDangerous: [
        { text: 'Explosive Goods (REX)' },
        { text: 'Gasses (RPG)' },
        { text: 'Flammable Liquids (RFL)' },
        { text: 'Flammable Solids (RFS)' },
        { text: 'Oxidizer (ROX)' },
        { text: 'Toxic (RPB) & Infections Substances (RI)' },
        { text: 'Radiactive Material (RFN)' },
        { text: 'Corrosive (RCM)' },
        { text: 'Misscelanous Dangerous Goods (RMD)' }
      ],
      error: {
        valueGoods: '',
        goods: ''
      },
      othersGoods: {
        show: false,
        value: ''
      }
    }
  },
  computed: {
    total_price () {
      return this.data.total_price
    },
    commoditiesHSCode () {
      return this.data.commoditiesHSCode
    },
    product_type () {
      return this.data.product_type
    },
    hs_code () {
      return this.data.hs_code
    },
    commoditiesClass () {
      return this.data.commoditiesClass
    },
    description () {
      return this.data.description
    },
    un_number () {
      return this.data.un_number
    },
    fileDocument () {
      return this.data.fileDocument
    }
  },
  watch: {
    total_price (data) {
      /* eslint-disable-next-line */
      this.error.total_price = (data === '' || parseInt(data) === 0) ? true : false
      this.$emit('inputData', this.data)
    },
    commoditiesHSCode (data) {
      /* eslint-disable-next-line */
      this.error.commoditiesHSCode = (data === '') ? true : false
      this.$emit('inputData', this.data)
    },
    product_type (data) {
      /* eslint-disable-next-line */
      this.error.product_type = (data === '') ? true : false
      this.$emit('inputData', this.data)
    },
    un_number (value) {
      /* eslint-disable-next-line */
      this.error.un_number = (value === '') ? true : false
      this.$emit('inputData', this.data)
    },
    hs_code (data) {
      /* eslint-disable-next-line */
      this.error.hs_code = (data === '') ? true : false
      this.$emit('inputData', this.data)
    },
    commoditiesClass () {
      this.$emit('inputData', this.data)
    },
    description (data) {
      /* eslint-disable-next-line */
      this.error.description = (data === '') ? true : false
      this.$emit('inputData', this.data)
    },
    fileDocument (value) {
      if (value) {
        const convertToMb = value.size / 1024 / 1024
        const maxSize = 5
        if (convertToMb >= maxSize) {
          this.error.fileDocument = 'Your file exceeded maximum requirement file'
        } else {
          this.error.fileDocument = ''
        }
        this.$emit('inputData', this.data)
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.$emit('chgHeader', this.header)
    },
    chooseProductType (type) {
      this.isGeneral = type === 'General Cargo'
      this.isSpecial = type === 'Special Cargo'
      this.isDangerous = type === 'Dangerous Goods'

      if (type !== this.isGoods) {
        this.kindOfGoods = 'What kind of goods you shipped ?'
        this.data.product_type = ''
        if (this.isGeneral) {
          this.data.commoditiesClass = 'GENCO'
          this.data.un_number = ''
          this.isGoods = type
        } else if (this.isSpecial) {
          this.data.un_number = ''
          this.data.commoditiesClass = 'SC'
          this.isGoods = type
        } else {
          this.data.commoditiesClass = 'DG'
          this.isGoods = type
        }
      }

      this.header.subtitle = type

      this.$emit('chgHeader', this.header)
      this.$emit('inputData', this.data)
    },
    selectedOption (params) {
      if (params === 'Others') {
        this.othersGoods.show = true
        if (this.othersGoods.value) {
          this.kindOfGoods = `Others - ${this.othersGoods.value}`
          this.data.product_type = `Others - ${this.othersGoods.value}`
        }
      } else {
        this.othersGoods.show = false
        this.kindOfGoods = params
        this.data.product_type = params
      }
    },
    handleFileUpload () {
      this.data.fileDocument = this.$refs.fileDocument.files[0]
      this.fileNameMSDS = this.$refs.fileDocument && this.$refs.fileDocument.files[0].name.length < 20 ? this.$refs.fileDocument.files[0].name : `${this.$refs.fileDocument.files[0].name.substr(0, 20)}...`
      const fileSize = this.$refs.fileDocument.files[0].size / 1024 / 1024
      this.error.fileDocument = !!((this.$refs.fileDocument && fileSize > 5))
      this.data.fileDocumentStat = !((this.$refs.fileDocument && fileSize > 5))
      this.error.fileType = !!((this.$refs.fileDocument.files[0].name.split('.').pop() === 'pptx' || this.$refs.fileDocument.files[0].name.split('.').pop() === 'ppt'))
      this.data.fileTypeStat = !((this.$refs.fileDocument.files[0].name.split('.').pop() === 'pptx' || this.$refs.fileDocument.files[0].name.split('.').pop() === 'ppt'))

      this.$emit('inputData', this.data)
    },

    ButtonNext () {
      this.$validator.validateAll().then((result) => {
        if (result && (this.data.valueGoods || this.data.product_type)) {
          this.error.valueGoods = ''
          this.error.goods = ''
          this.$emit('tabIndex')
          this.$emit('inputData', this.data)
        }
        if (!this.data.valueGoods || this.data.valueGoods < 1) {
          this.error.valueGoods = 'The Value of goods field is required'
        }
        if (!this.data.product_type) {
          this.error.goods = 'The Value of kind of goods field is required'
        }
      })
    },

    ButtonPrev () {
      this.$emit('tabIndexPrev')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contract/ProductType.vue